import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-2xl text-primary uppercase" }
const _hoisted_2 = {
  key: 0,
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<title>ui/search</title><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"3-1-Produkt:-Zamówienie\" transform=\"translate(-898, -788)\" fill=\"#338F70\" fill-rule=\"nonzero\"><g id=\"wybor-leku\" transform=\"translate(416, 708)\"><g id=\"input\" transform=\"translate(0, 54)\"><g id=\"search\" transform=\"translate(468, 12)\"><g id=\"ui/search\" transform=\"translate(14, 14)\"><path d=\"M8.20517669,16.4102244 C4.34587517,16.4100212 1.00840679,13.7202429 0.188236187,9.94909873 C-0.631934416,6.17795455 1.28693123,2.34499787 4.79754778,0.741944637 C8.30816432,-0.861108594 12.4614137,0.199137516 14.7740777,3.28876426 C17.0867417,6.37839101 16.9335765,10.6620977 14.4061593,13.5786659 C14.1667007,13.8578193 13.7961039,13.9873887 13.4348742,13.9182503 C13.0736445,13.849112 12.777086,13.5918509 12.6576337,13.2440029 C12.5381814,12.896155 12.6141233,12.5109758 12.8566675,12.2344992 C14.8491565,9.92722658 14.8443808,6.50668306 12.8454569,4.20498319 C10.8465329,1.90328332 7.46039952,1.4192986 4.89671651,3.06885876 C2.33303351,4.71841892 1.37021909,8.00066345 2.63656875,10.7737263 C3.90291842,13.5467892 7.01392691,14.9686777 9.93947026,14.1115223 C10.481727,13.955531 11.0481481,14.266838 11.2071217,14.808228 C11.3660953,15.3496179 11.0579107,15.9177439 10.517404,16.079695 C9.76637224,16.2995942 8.9877391,16.4108976 8.20517669,16.4102244 L8.20517669,16.4102244 Z\" id=\"Path\"></path><path d=\"M18.9745108,20 C18.7024407,20.0003076 18.4414701,19.8921543 18.2493757,19.6994836 L12.6082959,14.0584038 C12.2139813,13.6568811 12.216899,13.0126066 12.614834,12.6146716 C13.012769,12.2167366 13.6570434,12.213819 14.0585662,12.6081335 L19.699646,18.2492133 C19.9928877,18.5425436 20.0805952,18.9836169 19.921882,19.3668185 C19.7631687,19.75002 19.3892798,19.9999108 18.9745108,20 Z\" id=\"Path\"></path></g></g></g></g></g></g>", 2)
const _hoisted_5 = [
  _hoisted_3
]
const _hoisted_6 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-primary",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "SearchForm__list" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { class: "text-primary underline my-1 md:mt-0 md:ml-4 text-sm" }, "Dodaj Iek", -1)
const _hoisted_12 = ["onClick"]

import { ref } from 'vue';
import axios from 'axios';


export default {
  __name: 'Search',
  props: {
    selectedMedications: {
        type: Array,
        required: true,
    },
    hasErrors: {
        type: Boolean,
        required: true,
    },
},
  emits: ['addItem'],
  setup(__props, { emit }) {

const props = __props;



const isOpen = ref(false);
const search = ref('');
const isLoading = ref(false);
const searchResults = ref([]);
const isInitiallyLoaded = ref(false);

let controller = null;

const toggleIsOpen = (status) => {
    setTimeout(() => {
        isOpen.value = status;
    }, 0);
};

const searchItem = (value) => {
    if (value.length > 1) {
        controller = new AbortController();
        isLoading.value = true;
        axios
            .get(`${jsData.siteUrl}/wp-json/doctor/v1/medications-list?search=${value}`, {
                signal: controller.signal,
            })
            .then((response) => {
                searchResults.value = response.data;
                isOpen.value = true;
                isLoading.value = false;
            });
    }
};

const prevValue = ref(search.value);

const handleInput = (event) => {
    const value = event.target.value;
    if (value === prevValue.value) {
        return;
    }
    if (timeout) {
        clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
        isInitiallyLoaded.value = true;
        searchItem(value);
        prevValue.value = value;
    }, 500);
};

let timeout = null;



const addItemToList = (item) => {
    if (!item.title || !item.title.length) return;

    emit('addItem', {
        ...item,
        variants: item.variants || null,
        selectedVariant:
            item.variants && item.variants !== 'custom' ? item.variants[0].single_dosage : null,
    });

    if (controller) {
        controller.abort();
    }

    isLoading.value = false;
    search.value = '';
    searchResults.value = [];
    isOpen.value = false;
};

return (_ctx, _cache) => {
  return (__props.selectedMedications.length < 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        tabindex: "-1",
        onFocusin: _cache[6] || (_cache[6] = $event => (toggleIsOpen(true))),
        onFocusout: _cache[7] || (_cache[7] = $event => (toggleIsOpen(false))),
        class: "SearchForm w-full relative"
      }, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["SearchForm__searchInput", { 'SearchForm__searchInput--hasErrors': __props.hasErrors }]),
          type: "text",
          placeholder: "Wpisz nazwę Ieku",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((search).value = $event)),
          onInput: handleInput,
          onKeyup: [
            _cache[1] || (_cache[1] = () => {}),
            _cache[2] || (_cache[2] = _withKeys($event => (addItemToList({ title: search.value, variants: 'custom' })), ["enter"]))
          ]
        }, null, 34), [
          [_vModelText, search.value]
        ]),
        _createElementVNode("button", {
          class: "Button--no-style SearchForm__submitButton flex items-center justify-center",
          type: "button",
          onClick: _cache[3] || (_cache[3] = $event => (addItemToList({ title: search.value, variants: 'custom' }))),
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("span", _hoisted_1, [
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
              : _createCommentVNode("", true),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ], 32),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          (!searchResults.value.length && search.value.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "Button--no-style SearchForm__list-item SearchForm__list-item--disabled flex flex-col md:flex-row md:items-center md:justify-between",
                onClick: _cache[5] || (_cache[5] = $event => (addItemToList({ title: search.value, variants: 'custom' })))
              }, [
                _createTextVNode(" Nie znaleziono Ieków w bazie. "),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "Button--no-style SearchForm__list-item",
              onClick: $event => (addItemToList(item)),
              key: item.id
            }, _toDisplayString(item.title), 9, _hoisted_12))
          }), 128))
        ], 512), [
          [_vShow, isOpen.value && !isLoading.value && isInitiallyLoaded.value]
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

}